module.exports = __webpack_public_path__ + "img/LATIN10_32.70ca424b.jpg";